import './App.styling';

import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import CookieConsent from '../../common/CookieConsent';
import ErrorBoundary from '../../common/ErrorBoundary';
import MobileRedirect from '../../common/MobileRedirect';
import Content from './content/Content';
import Header from './header/Header';

class App extends React.Component {
    render() {
        return (
            <ErrorBoundary>
                <BrowserRouter>
                    <div>
                        {process.env.BUILD_CONFIG !== 'LOCAL' ?
                            <MobileRedirect/> : null}
                        <Header/>
                        <Content/>
                        {process.env.BUILD_CONFIG !== 'LOCAL' ?
                            <CookieConsent/> : null}
                    </div>
                </BrowserRouter>
            </ErrorBoundary>
        );
    }
}

export default App;
